export var ERR_REDIRECT = {
    message: 'Redirecting',
};
